module.exports = __webpack_public_path__ + "img/img1.13ab1d02.png";